(ns machtfit.language
  (:require [machtfit.init :as-alias init]
            [machtfit.navigation :as-alias navigation]
            [re-frame.core :as rf])
  (:import [goog.i18n NumberFormatSymbols NumberFormatSymbols_de NumberFormatSymbols_en]))

(def default-language :de)

(defn coerce-language [language]
  (get #{:de :en} language default-language))

(def ^:private number-format-symbols
  {:de NumberFormatSymbols_de
   :en NumberFormatSymbols_en})

(rf/reg-cofx ::document-language
  (fn [cofx _]
    (assoc cofx :document-language (keyword js/document.documentElement.lang))))

(rf/reg-event-fx ::init [(rf/inject-cofx ::document-language)]
  (fn [{:keys [db document-language]} _]
    (let [language (coerce-language document-language)]
      {:db (assoc db :language language)
       ::set language})))

(rf/reg-event-fx ::change
  (fn [_ [_ language]]
    (let [language (coerce-language language)]
      {:dispatch [::set language]
       ::set language})))

(rf/reg-event-db ::set
  (fn [db [_ language]]
    (assoc db :language language)))

(rf/reg-fx ::set
  (fn [language]
    (->> language
         number-format-symbols
         (set! NumberFormatSymbols))
    (set! js/document.cookie (str "django_language = " (name language) "; path=/"))))

(defn- n-th [n]
  (let [last-digit (mod n 10)
        postfix (cond
                  (<= 11 (mod n 100) 13) "th"
                  (= 1 last-digit) "st"
                  (= 2 last-digit) "nd"
                  (= 3 last-digit) "rd"
                  :else "th")]
    (str n postfix)))

(defn ordinal [n]
  (case @(rf/subscribe [:get [:language]])
    :de (str n ".")
    :en (n-th n)))

(defn mini-switcher []
  (let [languages [:de :en]
        last-language (last languages)
        selected @(rf/subscribe [:get [:language]])]
    [:div.language-switcher__mini
     (for [language languages]
       ^{:key language}
       [:<>
        [:button {:on-click #(rf/dispatch [::change language])
                  :class (when (= selected language) "active")} language]
        (when-not (= last-language language) [:span.pipe])])]))

(defn- static-switcher [language-key text]
  (when (and @(rf/subscribe [::navigation/url :set-language])
             @(rf/subscribe [::navigation/csrf-token]))
    [:form {:action @(rf/subscribe [::navigation/url :set-language])
            :method "post"}
     [:input {:type "hidden"
              :name "csrfmiddlewaretoken"
              :value @(rf/subscribe [::navigation/csrf-token])}]
     [:button
      {:name "language"
       :value (name language-key)
       :type "submit"}
      text]]))

(defn switcher [spa-style? language-key short-name long-name]
  (if spa-style?
    [:button {:class (when (= @(rf/subscribe [:get [:language]]) language-key) "active")
              :on-click #(rf/dispatch [::change language-key])}
     [:span.long long-name]
     [:span.short short-name]]
    [static-switcher
     language-key [:<> [:span.long long-name] [:span.short short-name]]]))
